import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import { Login } from "../../pages/login";
import { Verify } from "../../pages/otp";

const routes = createRoutesFromElements(
  <>
    <Route path="/" element={<Navigate to="/login" />} />
    <Route path="/login" element={<Login />} />
    <Route path="/verify" element={<Verify />} />
  </>
);

const router = createBrowserRouter(routes, {
  basename: "/admin", 
});

export function Router() {
  return <RouterProvider router={router} />;
}
